import { useMutation } from "@tanstack/react-query";
import { supportReportsApi } from "@/api/support/support-reports-api";
import type { SupportReportCreate } from "@/types/support/api-types/support-report-types";

export const useSendSupportReport = () => {
  return useMutation({
    mutationFn: (report: SupportReportCreate) => supportReportsApi.send(report),
  });
};
